import {ErrorHandler, Inject, Injectable, Injector} from '@angular/core';
import {IErrorContext, ServerLoggerService} from './server-logger.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MesHttpStatusHandlerService} from "../mes-http-status-handler.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private mesHttpStatusHandlerService: MesHttpStatusHandlerService, private loggerService: ServerLoggerService) {
  }

  handleError(error: Error | HttpErrorResponse) {
    if(error.message.startsWith('NG0100:'))
      return;

    if ((error as any)?.rejection instanceof HttpErrorResponse) {
      error = (error as any)?.rejection;
    }
    if ((error as any)?.rejection instanceof Error) {
      error = (error as any)?.rejection;
    }

    if (!(error instanceof HttpErrorResponse)) {
      // Client Error Happend
      // Send the error to the server and then
      // redirect the user to the page with all the info
      if (this.loggerService) {
        this.loggerService
          .log(error)
          .subscribe((errorWithContextInfo: IErrorContext) => {
            this.mesHttpStatusHandlerService.globalError.next(errorWithContextInfo);
          });
      }
    }
    console.error(error);
  }
}
